import { Req } from "@larner.dev/req";

const GENERIC_API_ERROR = "Something went wrong. Please try again.";
const NETWORK_API_ERROR =
  "We couldn't reach Green Flag. Check your connection and try again.";

/**
 * A Req whose errors always carry a `message` a person can read.
 *
 * The API answers a failed request with `{ code, params? }` and never a
 * `message` (koa-object-router writes the body). Req then fills `message`
 * with the raw response text: JSON like `{"code":"WRONG_EVENT"}`, or a
 * proxy's HTML error page. Screens fall back to `error.message` when they
 * have no wording of their own for a code, so that text reached users.
 * `code`, `status` and `params` are left alone for screens to branch on.
 *
 * Every request goes through `standardRequest` (Req's get/put/post/delete
 * call it), so this is where the message is replaced. Req's own "error"
 * handlers can't do this: they run on a timer, after the error has already
 * been thrown and copied by useReq.
 */
export class ReadableErrorReq extends Req {
  async standardRequest<T = unknown>(
    ...args: Parameters<Req["standardRequest"]>
  ): Promise<T> {
    try {
      return await super.standardRequest<T>(...args);
    } catch (error) {
      if (error instanceof Error) {
        const { code } = error as { code?: string };
        error.message =
          code === "NETWORK" ? NETWORK_API_ERROR : GENERIC_API_ERROR;
      }
      throw error;
    }
  }
}
